interface S3UploaderListener {
  /**
   * Invoked when files to upload are selected.
   */
  started?(files: FileList): void;
  /**
   * Invoked when successfully uploaded
   */
  done?(urls: string[]): void;
  /**
   * Invoked when failed to upload
   */
  failed?(error: Error): void;
}

interface S3UploaderOptions {
  id: string;
  multiple?: boolean;
  accept?: string;
}

interface S3UploaderPolicy {
  key: string;
  acl: string;
  Policy: string;
  Signature: string;
  AWSAccessKeyId: string;
  _meta: {
    host: string;
    url: string;
  };
}

/**
 *
 */
class S3Uploader {
  private options: S3UploaderOptions;
  private listener?: S3UploaderListener;

  constructor(options: S3UploaderOptions) {
    this.options = {
      multiple: false,
      accept: "image/*",
      ...options,
    };
  }

  public getId() {
    return `s3_uploader__${this.options.id}`;
  }

  public getPropsForInput() {
    return {
      type: "file",
      id: this.getId(),
      accept: this.options.accept,
      multiple: this.options.multiple,
    };
  }

  public listen(listener: S3UploaderListener) {
    this.listener = listener;
  }

  public dispose() {
    this.listener = undefined;
  }

  public choose() {
    const elem = document.getElementById(this.getId());
    if (!elem) {
      throw new Error(`Target element was not found. Be sure to exist input[type=\'type\'] with id="${this.getId()}"`);
    }
    const onChange = async (event: Event) => {
      const files: FileList = (event.target as any).files;
      if (files.length === 0) {
        elem.removeEventListener("change", onChange);
        return;
      }
      if (this.listener && this.listener.started) {
        this.listener.started(files);
      }
      let urls: string[];
      try {
        urls = await Promise.all(Array.from(files).map(file => this.upload(file)));
      } catch (e) {
        if (this.listener && this.listener.failed) {
          this.listener.failed(e);
        }
        elem.removeEventListener("change", onChange);
        return;
      }
      if (this.listener && this.listener.done) {
        this.listener.done(urls);
      }
      elem.removeEventListener("change", onChange);
    };
    elem.addEventListener("change", onChange);
    elem.click();
  }

  public async upload(file: File) {
    const res = await fetch("/upload_images/s3_fields?need_meta=true", { method: "GET", credentials: "same-origin" });
    const policy: S3UploaderPolicy = await res.json();
    const formData = new FormData();
    const meta = policy._meta;
    delete policy._meta;
    Object.entries(policy).forEach(([key, val]) => {
      formData.append(key, val);
    });
    formData.append("Content-Type", file.type);
    formData.append("file", file);
    await fetch(meta.host, { method: "POST", body: formData });
    return meta.url;
  }
}

export default S3Uploader;



// WEBPACK FOOTER //
// ./frontend/src/lib/S3Uploader.ts